import { BrainAdapter, BrainGraphqlAdapter } from "../api/BrainAdapter";
import { GlobalAdapter } from "./GlobalAdapter";
import { GlobalApi } from "../api/GlobalApi";
import { GraphqlApi } from "../api/GraphqlApi";
import { OpenAiApi } from "../api/OpenAiApi";
import { StockApi } from "../api/StockApi";
import { UserApi } from "../api/UserApi";
import { RetrievalApi } from "../api/RetrievalApi";
import { GraphqlClient } from "../cutil/GraphqlClient";
import { RestClient } from "../cutil/RestClient";
import { StreamClient } from "../cutil/StreamClient";
import { BluePrintApi } from "./BluePrintApi";
import { UploadApi } from "../api/UploadApi";
import { GlobalClient } from "../cutil/GlobalClient";
import { PayWallApi } from "./PayWallApi";
import { DomainApi } from "./DomainApi";
import { SaaSMonetizationApi } from "./SaaSMonetizationApi";
export class BrainClient {
    constructor(authStore, abortManager = undefined, projectStore) {
        this.authStore = authStore;
        this.abortManager = abortManager;
        this.projectStore = projectStore;
        this.restAdapter = new BrainAdapter(authStore, projectStore);
        const graphqlAdapter = new BrainGraphqlAdapter(authStore, projectStore);
        const globalAdapter = new GlobalAdapter();
        this.restClient = new RestClient(this.restAdapter, abortManager);
        this.graphqlClient = new GraphqlClient(graphqlAdapter, abortManager);
        this.streamClient = new StreamClient(this.restAdapter, abortManager);
        this.globalClient = new GlobalClient(globalAdapter, abortManager);
    }
    get graphql() {
        return new GraphqlApi(this.graphqlClient);
    }
    get user() {
        return new UserApi(this.restClient);
    }
    get openAi() {
        return new OpenAiApi(this.restClient, this.streamClient);
    }
    get global() {
        return new GlobalApi(this.globalClient);
    }
    get stock() {
        return new StockApi(this.restClient);
    }
    get bluePrint() {
        return new BluePrintApi(this.restClient);
    }
    get retrieval() {
        return new RetrievalApi(this.restClient);
    }
    get upload() {
        return new UploadApi(this.restClient, this.restAdapter);
    }
    get payWall() {
        return new PayWallApi(this.restClient);
    }
    get domain() {
        return new DomainApi(this.restClient);
    }
    get saaSMonetization() {
        return new SaaSMonetizationApi(this.restClient);
    }
}
